import * as React from "react";
import { AccountModelPortfolioAction } from "../Actions/AccountModelPortfolioActions";
import { CashDetailPopupView } from "./CashDetailPopupView";
import { CashModelTypeMap, CashModelTypeOptions, CashUnModelTypeOptions, Contents } from "../Resource/Contents";
import { AccountModelPortfolioStore } from "../Store/Variable";
import { TransactionHistoryPopupView } from "../Components/TransactionHistoryPopupView";
import { CommonHelper, Dictionary } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { SelectEditorFactory } from "../../../../../../../../react-core/Html/Factories/SelectEditorFactory";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../../../react-core/Html/PartLoading";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { ObjectComparer } from "../../../../../../../../react-core/Utils/ObjectComparer";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SortDirection } from "../../../../../../../../Wrap/Core/SortingAndPaging/SortDirection";
import { CashTransactionTypes } from "../../../../../../../../Wrap/Models/Domains/Transactions/Cash/CashTransactionTypes";
import { CashTransaction } from "../../../../../../../../Wrap/Models/Domains/Transactions/CashTransaction";
import { CashTransactionCollection } from "../../../../../../../../Wrap/Models/Domains/Transactions/CashTransactionCollection";
import { AccountModelView } from "../../../../../../../../Wrap/Models/Domains/Transactions/Investments/AccountModelView";
import { Alert } from "../../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../../Shared/Entities/Constants/AlertConstants";
import { ExcelExportAction } from "../../../../../../../Shared/ExcelExport/Actions/ExcelExportAction";
import { ExcelExportButton } from "../../../../../../../Shared/ExcelExport/ExcelExportButton";
import { EyeIcon } from "../../../../../../../Shared/Process/Process/EyeIcon";
import { Table, ITableConfig, sortDirection } from "../../../../../../../Shared/Table/Table";

interface ICashProps {
    hierarchyId: string;
    data: CashTransactionCollection;
    fromDate?: Date;
    toDate?: Date;
    fromInception?: boolean;
    cashTransactionType?: CashTransactionTypes;
    onTableChange: (transSource, modelId, sortDirection, minRow, maxRow, newHierarchyId?) => void;
}

interface ICashState {
    transSource: string;
    modelFundInstrumentId: number;
    modelId: number;
    sortDirection: SortDirection;
    currentPage: number;
    isHistoryPopUp: boolean;
    selectedRow: CashTransaction;
    isExDateASC: boolean;
    newHierarchyId: string;
    accountModelView: AccountModelView;
}

export class Cash extends FormComponent<ICashProps, ICashState> {
    constructor(props: ICashProps) {
        super(props);

        this.state = {
            transSource: this.getTransSource(), //Set default transactionType to "All"
            modelFundInstrumentId: 0,
            modelId: 0,
            sortDirection: SortDirection.Descending,
            currentPage: 1,
            isHistoryPopUp: false,
            selectedRow: null,
            isExDateASC: false,
            newHierarchyId: null,
            accountModelView: null,
        };

        this.subscribeToStore(AccountModelPortfolioStore, () => this.onAccoutModelViewStoreChange());
    }

    componentDidMount() {
        this.onAccoutModelViewStoreChange();
    }

    private getTransSource() {
        if (this.props.cashTransactionType == CashTransactionTypes.CapitalOut) {
            return CashUnModelTypeOptions[CashTransactionTypes.CapitalOut].key;
        } else if (this.props.cashTransactionType == CashTransactionTypes.CapitalIn) {
            return CashUnModelTypeOptions[CashTransactionTypes.CapitalIn].key;
        } else {
            return CashUnModelTypeOptions[0].key;
        }
    }

    private onAccoutModelViewStoreChange() {
        const data = AccountModelPortfolioStore.getAccountModelData();
        if (!data) {
            if (this.props.hierarchyId) {
                AccountModelPortfolioAction.getAccountModelPortfolio(this.props.hierarchyId, true);
            }
        } else {
            const data = AccountModelPortfolioStore.getAccountModelData();
            const isSame = ObjectComparer.isSame(data, this.state.accountModelView);

            if (!isSame) {
                if (this.props.hierarchyId) {
                    AccountModelPortfolioAction.getAccountModelPortfolio(this.props.hierarchyId, true);
                }
                this.setState({
                    accountModelView: AccountModelPortfolioStore.getAccountModelData(),
                });
            }
        }
    }

    private getData() {
        const { transSource, sortDirection, currentPage, modelId, newHierarchyId } = this.state;
        const minRow = (currentPage - 1) * 10 + 1;
        const maxRow = currentPage * 10;
        this.props.onTableChange(transSource, modelId, sortDirection, minRow, maxRow, newHierarchyId);
    }

    private getTransactionTypeOptions(): Dictionary[] {
        const { modelFundInstrumentId } = this.state;
        let _options: Dictionary[] = [];
        if (modelFundInstrumentId == 0) {
            _options = CashUnModelTypeOptions;
        } else {
            _options = CashModelTypeOptions;
        }
        return _options;
    }

    private getModelPortfolioOptions(hierarchyId: string): Dictionary[] {
        const data = AccountModelPortfolioStore.getAccountModelData();
        if (data) {
            const ckIsSelectPortfolio = this.ckIsSelectPortfolio(hierarchyId);
            if (ckIsSelectPortfolio) {
                return this.getAllSubAccountOptions();
            } else {
                return this.getSubAccountOptionsFromHierarchyId(hierarchyId);
            }
        } else {
            const _subAccoutOptions: Dictionary[] = [];
            return _subAccoutOptions;
        }
    }
    private ckIsSelectPortfolio(hierarchyId: string): boolean {
        const data = AccountModelPortfolioStore.getAccountModelData();
        if (data) {
            if (hierarchyId && hierarchyId.length != data.HeadAccount.HierarchyId.length) {
                let str = "";
                const diff =
                    data.HeadAccount.HierarchyId.split("-")[1].toString().length -
                    hierarchyId.split("-")[1].toString().length;
                for (let i = 0; i < diff; i++) {
                    str += "0";
                }
                str = "-" + str;
                const _hierarchyId = hierarchyId.split("-")[0] + str + hierarchyId.split("-")[1];
                return _hierarchyId == data.HeadAccount.HierarchyId;
            } else {
                return hierarchyId == data.HeadAccount.HierarchyId;
            }
        } else {
            return false;
        }
    }
    private getAllSubAccountOptions(): Dictionary[] {
        const _subAccoutOptions: Dictionary[] = [];
        const data = AccountModelPortfolioStore.getAccountModelData();
        if (data) {
            data.SubAccounts.map((item) => {
                const name =
                    item.ModelDisplayName + " " + item.SubClaccountId.substr(item.SubClaccountId.indexOf("-") + 1);
                _subAccoutOptions.push({ key: item.ModelFundInstrumentId + "", value: name });
            });
        }
        return _subAccoutOptions;
    }
    private getSubAccountOptionsFromHierarchyId(hierarchyId: string): Dictionary[] {
        const _subAccoutOptions: Dictionary[] = [];
        const data = AccountModelPortfolioStore.getAccountModelData();
        if (data) {
            const findSubAccounts = data.HeadAccount.SubAccounts.filter((x) => x.HierarchyId == hierarchyId);
            if (findSubAccounts.length > 0) {
                const clAccountId = findSubAccounts[0].ClAccountId;
                data.SubAccounts.map((item) => {
                    if (item.SubClaccountId == clAccountId) {
                        const name =
                            item.ModelDisplayName + " " + item.SubClaccountId.substr(item.SubClaccountId.indexOf("-"));
                        _subAccoutOptions.push({ key: item.ModelFundInstrumentId + "", value: name });
                    }
                });
            }
        }
        return _subAccoutOptions;
    }

    private onModelPortfolioSelectChange(modelFundInstrumentId: string) {
        const { hierarchyId, onTableChange } = this.props;
        const { transSource } = this.state;
        const data = AccountModelPortfolioStore.getAccountModelData();
        if (data) {
            if (modelFundInstrumentId) {
                const findsubAccounts = data.SubAccounts.filter(
                    (x) => x.ModelFundInstrumentId + "" == modelFundInstrumentId
                );
                if (findsubAccounts.length > 0) {
                    const subAccount = findsubAccounts[0];
                    const modelFundInstrumentId = subAccount.ModelFundInstrumentId;
                    const inceptionDate = (subAccount.InceptionDate + "").split("T")[0];
                    let hierarchyId = null;
                    const ckIsSelectPortfolio = this.ckIsSelectPortfolio(this.props.hierarchyId);
                    if (!ckIsSelectPortfolio) {
                        const account = data.HeadAccount.SubAccounts.filter(
                            (x) => x.ClAccountId == subAccount.SubClaccountId
                        )[0];
                        hierarchyId = account ? account.HierarchyId : null;
                    } else {
                        hierarchyId = data.HeadAccount.HierarchyId;
                    }
                    const { newHierarchyId, modelId } = this.getHierarchyIdAndModelId(
                        hierarchyId,
                        modelFundInstrumentId
                    );
                    this.setState({ newHierarchyId: newHierarchyId, modelId: modelId }, () => {
                        onTableChange(transSource, modelId, SortDirection.Descending, 1, 10, newHierarchyId);
                    });
                }
            } else {
                // if select all
                const { newHierarchyId, modelId } = this.getHierarchyIdAndModelId(hierarchyId, modelFundInstrumentId);
                this.setState({ newHierarchyId: newHierarchyId, modelId: modelId }, () => {
                    onTableChange(transSource, modelId, SortDirection.Descending, 1, 10, newHierarchyId);
                });
            }
        }
    }

    private getHierarchyIdAndModelId(hierarchyId, modelFundInstrumentId) {
        const data = AccountModelPortfolioStore.getAccountModelData();
        let _hierarchyId = "";
        let _modelId = 0;

        if (modelFundInstrumentId) {
            const isPortfolio = hierarchyId == data.HeadAccount.HierarchyId;
            if (isPortfolio) {
                const finds = data.SubAccounts.filter((x) => x.ModelFundInstrumentId == modelFundInstrumentId);
                if (finds && finds.length > 0) {
                    const subClaccountId = finds[0].SubClaccountId;
                    const findObj = data.HeadAccount.SubAccounts.filter((x) => x.ClAccountId == subClaccountId);
                    if (findObj && findObj.length > 0) {
                        _hierarchyId = findObj[0].HierarchyId;
                    }
                    _modelId = finds[0].ModelId;
                }
            } else {
                const findDatas = data.SubAccounts.filter((x) => x.ModelFundInstrumentId == modelFundInstrumentId);
                _modelId = findDatas.length > 0 ? findDatas[0].ModelId : _modelId;
                _hierarchyId = hierarchyId;
            }
        } else {
            _hierarchyId = hierarchyId;
        }
        return { newHierarchyId: _hierarchyId, modelId: _modelId };
    }

    private renderModelPortfolioSelect(): JSX.Element {
        const { modelFundInstrumentId } = this.state;
        const ModelPortfolioSelect = SelectEditorFactory.create<string>();
        const { hierarchyId } = this.props;
        const _modelPortfolioOptions = this.getModelPortfolioOptions(hierarchyId);
        if (_modelPortfolioOptions) {
            return (
                <div className="col-12 col-sm-fluid col-max-245">
                    <ModelPortfolioSelect
                        label="MPS model"
                        options={_modelPortfolioOptions.map((item) => item.key)}
                        getText={(key) => CommonHelper.getOptionsTxt(key, _modelPortfolioOptions)}
                        selected={modelFundInstrumentId + ""}
                        placeholder="Please select"
                        onChange={(val) => {
                            this.setState({ modelFundInstrumentId: Number(val) }, () => {
                                this.onModelPortfolioSelectChange(val);
                            });
                        }}
                    />
                </div>
            );
        } else {
            return null;
        }
    }

    private renderElement(): JSX.Element {
        const { modelId, transSource, newHierarchyId } = this.state;
        const TransactionTypeSelect = SelectEditorFactory.create<string>();
        const _TransTypeOptions = this.getTransactionTypeOptions();
        return (
            <div>
                <hr className="divider mt-15 mb-30" />
                <div className="row">
                    <div className="col-12 col-sm-fluid col-max-245">
                        <TransactionTypeSelect
                            key="TransactionType"
                            label="Transaction type"
                            selected={_TransTypeOptions.filter((x) => x.key == transSource)[0].key + ""}
                            options={_TransTypeOptions.map((item) => item.key + "")}
                            getText={(x) => CommonHelper.getOptionsTxt(x, _TransTypeOptions)}
                            onChange={(val) => {
                                const value = _TransTypeOptions.filter((x) => x.key == val)[0].key;
                                this.setState({ transSource: value }, () => {
                                    this.props.onTableChange(
                                        value,
                                        modelId,
                                        SortDirection.Descending,
                                        1,
                                        10,
                                        newHierarchyId
                                    );
                                });
                            }}
                        />
                    </div>
                    {this.renderModelPortfolioSelect()}
                </div>
                {this.renderTableContent()}
                {this.renderHistoryPopUp()}
            </div>
        );
    }

    private renderTableContent() {
        const { currentPage } = this.state;
        const { data } = this.props;
        if (!data) {
            return <PartLoading isLoading={true} />;
        } else if (data && data.CashTransactions.length < 1) {
            return <Alert alertType={AlertType.Warning} message={Contents.NoCashDataErrorMessage} />;
        } else {
            return (
                <div className="mb-50">
                    {this.renderTableFilter()}
                    <Table
                        data={data.CashTransactions}
                        col={this.getCashTableColumn()}
                        needPagination={{
                            totalNumOfResult: data.TotalRows,
                            currentPage: currentPage,
                            onPaginationChange: (pageIndex, pageSize) => {
                                this.setState(
                                    {
                                        currentPage: pageIndex,
                                    },
                                    () => {
                                        this.getData();
                                    }
                                );
                            },
                        }}
                    />
                </div>
            );
        }
    }

    private getCashTableColumn() {
        const { isExDateASC, modelFundInstrumentId } = this.state;

        const tableColConfig: ITableConfig[] = [
            {
                title: "Date",
                key: "LedgerDate",
                render: (data, row: CashTransaction, index) => {
                    return JsonDateParser.getFormatDate(row.LedgerDate, "dd/MM/yyyy");
                },
                sorter: () => {
                    this.setState(
                        {
                            sortDirection: isExDateASC ? SortDirection.Descending : SortDirection.Ascending,
                            isExDateASC: !isExDateASC,
                        },
                        () => {
                            this.getData();
                        }
                    );
                },
                sortDirection: isExDateASC ? sortDirection.ASC : sortDirection.DESC,
                thCssWrapper: "ctable-sort",
            },
            {
                title: "Product",
                key: "ProductDisplayName",
            },
            {
                title: "Cash transaction",
                key: "Narrative",
                thCssWrapper: "cell-22",
            },
            {
                title: "Transaction type",
                key: "MovementType",
                thCssWrapper: "cell-12",
                render: (data, row: CashTransaction, index) => {
                    return CashModelTypeMap[row.MovementType];
                },
            },
            {
                title: "Money in",
                key: "Amount",
                thCssWrapper: "cell-right",
                tdCssWrapper: "cell-right text-positive",
                render: (data, row, index) => {
                    if (data >= 0) {
                        return MoneyDisplayHelper.FromatMoneyDisplay(data, CurrencyCode.GBP, true, 2);
                    } else {
                        return null;
                    }
                },
            },
            {
                title: "Money out",
                key: "Amount",
                thCssWrapper: "cell-right",
                tdCssWrapper: "cell-right",
                render: (data, row, index) => {
                    if (data < 0) {
                        return MoneyDisplayHelper.FromatMoneyDisplay(data, CurrencyCode.GBP, true, 2);
                    } else {
                        return null;
                    }
                },
            },
            {
                title: "Balance",
                key: "Balance",
                thCssWrapper: "cell-right",
                tdCssWrapper: "cell-right",
                render: (data, row, index) => {
                    if (data == 0 || data) {
                        return MoneyDisplayHelper.FromatMoneyDisplay(data, CurrencyCode.GBP, true, 2);
                    }
                },
            },
            {
                title: "Capital In/Out",
                key: "MovementType",
                thCssWrapper: "cell-12",
                render: (data, row: CashTransaction, index) => {
                    return [
                        CashTransactionTypes.CapitalIn,
                        CashTransactionTypes.CapitalOut,
                        CashTransactionTypes.Withdrawal,
                    ].includes(row.MovementType)
                        ? "Yes"
                        : "No";
                },
            },
            modelFundInstrumentId < 1
                ? {
                      title: "Detail",
                      key: "TransID",
                      render: (data, row, index) => {
                          return (
                              // <button type="button" className="forward-button in-table mr-4 label-sr-only">
                              //     <span className="icon" aria-hidden={true}></span>
                              //     <span className="sr-only">{">>"}</span>
                              // </button>
                              <button className="eye-button label-sr-only">
                                  <EyeIcon />
                                  <span className="text">View transaction detail</span>
                              </button>
                          );
                      },
                      onClick: (data, row: CashTransaction, index) => {
                          this.setState({ selectedRow: row, isHistoryPopUp: true });
                      },
                      tdCssWrapper: "cell-center",
                      thCssWrapper: "cell-center",
                  }
                : {},
        ]; // all table column config

        return tableColConfig;
    }

    private renderTableFilter() {
        const { transSource, sortDirection, modelId, newHierarchyId } = this.state;
        const { fromDate, toDate, hierarchyId, fromInception } = this.props;
        return (
            <div className="row row-right mb-10">
                <div className="col-auto col-middle">
                    <ExcelExportButton
                        onRequestReport={() => {
                            return ExcelExportAction.generateCashTransactionReport(
                                newHierarchyId ? newHierarchyId : hierarchyId,
                                fromDate,
                                toDate,
                                fromInception,
                                transSource as any,
                                modelId,
                                sortDirection
                            );
                        }}
                        selectedAccount={newHierarchyId ? newHierarchyId : hierarchyId}
                    ></ExcelExportButton>
                </div>
            </div>
        );
    }

    private renderHistoryPopUp(): JSX.Element {
        const { isHistoryPopUp, selectedRow } = this.state;
        if (isHistoryPopUp) {
            let psOrderType = "";
            let cashId = "0";
            if (selectedRow.Reference.substr(0, 2).toUpperCase() == "AW") {
                psOrderType = "AW";
                cashId = selectedRow.Reference.substring(2);
            } else if (selectedRow.Reference.substr(0, 4).toUpperCase() == "CASH") {
                psOrderType = "CASH";
                cashId = selectedRow.Reference.substring(4);
            } else {
                psOrderType = "N/A";
            }
            if (psOrderType == "AW") {
                return (
                    <TransactionHistoryPopupView
                        showBox={isHistoryPopUp}
                        transId={selectedRow.TransId}
                        orderId={cashId}
                        onChange={() => {
                            this.setState({ isHistoryPopUp: false });
                        }}
                    />
                );
            } else {
                return (
                    <CashDetailPopupView
                        showBox={isHistoryPopUp}
                        transId={selectedRow.TransId}
                        orderId={Number(cashId)}
                        chequeRef={selectedRow.ChequeReference}
                        cashAmount={selectedRow.Amount}
                        productName={selectedRow.ProductDisplayName}
                        clAccountId={selectedRow.ClAccountId}
                        onChange={() => {
                            this.setState({ isHistoryPopUp: false });
                        }}
                    />
                );
            }
        }
        return null;
    }

    render() {
        return this.renderElement();
    }
}
